export class BeatOnset {
  private previous = 0;
  private fastFlux = 0;
  private meanFlux = 0;
  private sinceBeat = 1;

  step(bass: number, dt: number, threshold: number): boolean {
    if (!Number.isFinite(bass) || !Number.isFinite(dt) || !Number.isFinite(threshold) || dt <= 0) return false;
    // Positive spectral change, scaled to time rather than display frame rate.
    const rise = Math.max(0, bass - this.previous) / (dt * 60);
    this.previous = bass;
    this.sinceBeat += dt;
    this.fastFlux += (rise - this.fastFlux) * (1 - Math.exp(-dt / 0.028));
    const fluxGate = Math.max(0.0035, this.meanFlux * 1.8);
    // Threshold is an absolute level gate in the same 0..1 units as the panel.
    // A fresh attack and cooldown prevent a held loud bass from retriggering.
    const onset = bass > threshold && rise > 0 && this.fastFlux > fluxGate && this.sinceBeat >= 0.27;
    this.meanFlux += (this.fastFlux - this.meanFlux) * (1 - Math.exp(-dt / 0.65));
    if (onset) this.sinceBeat = 0;
    return onset;
  }
}
